export const DEFAULT_APP_STORE_URL =
  'https://apps.apple.com/us/app/joyajoy/id1530659435';

export const DEFAULT_TRY_CLASSROOMID =
  process.env.NODE_ENV === 'development'
    ? '08a9e109-d00a-48f0-aeeb-fc3e3b08942a'
    : '2535a644-a630-49f1-8b97-b20c2586f78d';
